import React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

const Subscription = () => {
  return (
    <Box sx={{ p: 2, textAlign: 'center' }}>
      <Typography variant="h6" gutterBottom fontWeight="bold" mb={5}>
        اشتراک ها
      </Typography>

      {/* کارت‌ها در خط یکسان */}
      <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2, justifyContent: 'center' }}>
        
        {/* طرح رایگان */}
        <Card sx={{ flex: 1, maxWidth: 300, backgroundColor: '#1e1e2f', color: 'white', borderRadius: '12px', boxShadow: '0 4px 12px rgba(97, 218, 251, 0.1)', transition: 'transform 0.2s', '&:hover': { transform: 'scale(1.03)' } }}>
          <CardContent>
            <Typography variant="h6" gutterBottom color="#61dafb">
              رایگان
            </Typography>
            <Typography variant="body2" display="block" mb={1}>۱ پروژه</Typography>
            <Typography variant="body2" display="block" mb={2}>۲۰ درخواست در روز</Typography>
            <Button variant="contained" color="primary" fullWidth disabled sx={{ fontWeight: 'bold', py: 0.8, fontSize: '0.8rem' }}>
              فعال
            </Button>
          </CardContent>
        </Card>

        {/* طرح استاندارد */}
        <Card sx={{ flex: 1, maxWidth: 300, backgroundColor: '#2a2a3a', color: 'white', borderRadius: '12px', boxShadow: '0 4px 12px rgba(255, 255, 256, 0.08)', transition: 'transform 0.2s', '&:hover': { transform: 'scale(1.03)' } }}>
          <CardContent>
            <Typography variant="h6" gutterBottom color="#ffd700">
              استاندارد
            </Typography>
            <Typography variant="body2" display="block" mb={1}>۵ پروژه</Typography>
            <Typography variant="body2" display="block" mb={2}>۵۰۰ درخواست در روز</Typography>
            <Button variant="contained" color="secondary" fullWidth sx={{ fontWeight: 'bold', py: 0.8, fontSize: '0.8rem' }}>
              خرید
            </Button>
          </CardContent>
        </Card>

        {/* طرح پیشرفته */}
        <Card sx={{ flex: 1, maxWidth: 300, backgroundColor: '#303B4B', color: 'white', borderRadius: '12px', boxShadow: '0 4px 12px rgba(255, 105, 180, 0.1)', position: 'relative', transition: 'transform 0.2s', '&:hover': { transform: 'scale(1.03)' } }}>
          {/* برچسب پیشنهادی */}
          <Box sx={{
            position: 'absolute',
            top: 10,
            right: 10,
            backgroundColor: '#ff4081',
            color: 'white',
            fontSize: '0.65rem',
            fontWeight: 'bold',
            px: 1,
            borderRadius: '4px'
          }}>پیشنهادی</Box>

          <CardContent>
            <Typography variant="h6" gutterBottom color="#ff4081">
              پیشرفته
            </Typography>
            <Typography variant="body2" display="block" mb={1}>پروژه نامحدود</Typography>
            <Typography variant="body2" display="block" mb={2}>درخواست نامحدود</Typography>
            <Button variant="contained" color="success" fullWidth sx={{ fontWeight: 'bold', py: 0.8, fontSize: '0.8rem' }}>
              خرید
            </Button>
          </CardContent>
        </Card>

      </Box>

      {/* دکمه ادامه */}
      <Button
        variant="outlined"
        color="info"
        fullWidth
        sx={{ mt: 4, borderColor: '#61dafb', color: '#61dafb', fontWeight: 'bold', py: 1 }}
        onClick={() => {}}
      >
        ادامه به صورت رایگان
      </Button>
    </Box>
  );
};

export default Subscription;